import { InvoiceTransaction } from '@/features/InvoiceReport/Edit/type';

export const ConvertInvoiceTransaction = (
  invoiceTransaction: Omit<InvoiceTransaction, 'isCurrencyJPY'>
): InvoiceTransaction => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return {
    ...invoiceTransaction,
    isCurrencyJPY() {
      return this.currency === 'JPY';
    },
  } as InvoiceTransaction;
};

export const ConvertInvoiceTransactions = (
  invoiceTransactions: Omit<InvoiceTransaction, 'isCurrencyJPY'>[]
) =>
  invoiceTransactions.map((invoiceTransaction) =>
    ConvertInvoiceTransaction(invoiceTransaction)
  );
